<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>邀请新用户配置</span>
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="start" label="进度">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.stage" />
            </template>
          </el-table-column>
          <el-table-column prop="buyNum" label="邀请数量">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.num" />
            </template>
          </el-table-column>

          <el-table-column prop="bet" label="奖励">
            <template v-slot:default="scope">
              <spen>{{ getPrize(scope.row.prize) }}</spen>
              <el-button type="primary" style="margin-left: 16px;" @click="drawer[scope.$index].visible = true">
                配置
              </el-button>
              <el-drawer
                title="我是标题"
                :visible.sync="drawer[scope.$index].visible"
                direction="rtl"
                size="780px"
                :before-close="(v)=>handleClose(v, scope.$index)"
              >
                <el-form :inline="true">
                  <el-row v-for="(r,i) in scope.row.prize" :key="i">
                    <el-form-item label="道具" style="margin-top: 5px;">
                      <el-select v-model.number="r.propsId" style="width: 130px;" placeholder="请选择">
                        <el-option
                          v-for="(item, index) in rewardType"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="奖品数量" style="margin-top: 5px;">
                      <el-input v-model.number="r.num" style="width: 130px;" placeholder="奖品数量" />
                    </el-form-item>
                    <el-form-item style="margin-top: 5px;" label="金币取值">
                      <el-select v-model.number="r.rtype" :disabled="r.propsId !== 14" placeholder="请选择" style="width: 120px" :prop="'formData.'+index+'.config' +i +'.rtype'">
                        <el-option
                          v-for="item in selectType1"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 5px;">
                      <el-button type="danger" @click="removeReward(scope.$index, i)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-form-item style="margin-top: 10px">
                    <el-button type="primary" @click="addReward(scope.$index)">+</el-button>
                  </el-form-item>
                </el-form>
              </el-drawer>
            </template>
          </el-table-column>

          <el-table-column>
            <template v-slot:default="scope">
              <el-button type="danger" @click="del(scope.$index)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>

        <div style="margin-top: 20px;text-align: center">
          <el-button type="primary" @click="add">+</el-button>
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>

      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'InvitationNewuser',
  data() {
    return {
      activeName: 'first',
      drawer: [{ visible: false }],
      rewardType: [],
      formData: [{
        'stage': 0,
        'num': 0,
        'prize': [],
        'status': 0
      }],
      selectType1: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ]
    }
  },
  created() {
    this.getRewardTypeData()
    this.getTables()
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
    getPrize(prize) {
      let str = ''
      prize.forEach(item => {
        for (const i in this.rewardType) {
          const val = this.rewardType[i]
          if (item.propsId === val.value) {
            str += val.label + '*' + item.num + '  '
          }
        }
      })
      return str
    },
    handleClose(done, index) {
      this.drawer[index].visible = false
    },
    onSubmit() {
      for (const i in this.formData) {
        const val = this.formData[i]
        if (val.stage === 0) {
          this.msgError('邀请进度不能是0')
          return
        }

        if (val.num === 0) {
          this.msgError('邀请数量不能是0')
          return
        }
      }

      const _data = JSON.stringify(this.formData)
      updateCommonCfg({ data: _data, name: 'inviteStageReward' }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCommonCfg({ name: 'inviteStageReward' }).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.drawer.push({ visible: false })
          })
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'stage': 0,
        'num': 0,
        'prize': [],
        'status': 0
      })
      this.drawer.push({ visible: false })
    },
    del(i) {
      this.formData = this.formData.filter((item, index) => {
        return index !== i
      })
    },
    addReward(index) {
      this.formData[index].prize.push({
        'propsId': 15,
        'rtype': 2,
        'num': 1
      })
    },
    removeReward(index, i) {
      this.formData[index].prize = this.formData[index].prize.filter((item, key) => {
        return key !== i
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
